<template lang="html">
    <nav class="topnav navbar-default">
        <img style="width: 302px; float: left; margin: 5px 0 5px 63px;"
             src="http://img.scwywh.com/wuyuan/admin/norisuke/吾言文化公司标志02_1481891930391.png" alt="">
        <ul>
            <li><a v-link="{path :'/index/pc', activeClass: 'active' }">首页</a></li>
            <li v-link-active><a v-link="{path :'/index/workList', activeClass: 'active' }">课件下载</a></li>
            <li v-link-active><a v-link="{path :'/index/listendownpc?type=en', activeClass: 'active' }">英语听力</a></li>
            <li v-link-active><a v-link="{path :'/index/listendownpc?type=cn', activeClass: 'active' }">语文听读</a></li>
            <li v-link-active><a v-link="{path :'/index/norisukeList', activeClass: 'active' }">产品展示</a></li>
            <li v-link-active><a v-link="{path :'/index/findinfopc', activeClass: 'active' }">公司文化</a></li>
            <li v-link-active><a v-link="{path :'/index/tellOur', activeClass: 'active' }">联系我们</a></li>
        </ul>
        <div class="sign">
            <template v-if="localdata.id">
                <strong>Hi,您好!{{localdata.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                <button type="button" class="btn btn-sm btn-primary" @click="out">注销登陆</button>
            </template>
            <template v-else>
                <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".login">登录</button>
                <button type="button" class="btn btn-success" data-toggle="modal" data-target=".reg">注册</button>
            </template>

        </div>
    </nav>
    <!-- Modal 登陆-->
    <div class="modal fade login" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-bg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span
                        aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h4 class="modal-title">登录</h4>
                </div>
                <div class="modal-body">
                    <form class="form-horizontal" role="form">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">邮箱</label>
                            <div class="col-sm-6">
                                <input type="email" class="form-control" placeholder="email" v-model="email">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">密码</label>
                            <div class="col-sm-6">
                                <input type="password" class="form-control" placeholder="密码" v-model="password">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">关闭</button>
                    <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="cLogin">登录
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal 注册-->
    <div class="modal fade reg" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-bg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span
                        aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h4 class="modal-title" id="myModalLabel">注册信息</h4>
                </div>
                <div class="modal-body">
                    <form class="form-horizontal" role="form">
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>姓名</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="姓名" v-model="reg.name">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>邮箱</label>
                            <div class="col-sm-8">
                                <input type="email" class="form-control" placeholder="邮箱" v-model="reg.email">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>电话</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="联系电话" v-model="reg.phone">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>地址</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="地址" v-model="reg.address">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>密码</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="密码" v-model="reg.password">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>确认密码</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="密码" v-model="reg.passwordS">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label"><strong class="red">*</strong>学校</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" placeholder="学校" v-model="reg.school">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">关闭</button>
                    <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="cReg">注册</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import M from '../../assets/common.js'
    import C from '../../assets/config.js'

    export default {
        data: () => ({
            host: C.host,
            URLcs: M.getUrlParams(),
            email: '',
            password: '',
            reg: {
                address: '',
                email: '',
                name: '',
                password: '',
                phone: '',
                school: '',
                passwordS: ''
            },
            localdata: {
                role: localStorage.getItem('wyrole'),
                name: localStorage.getItem('wyname'),
                id: localStorage.getItem('wyid')
            },
        }),
        events: {},
        components: {},
        created: function () {

        },
        ready: function () {

        },
        methods: {
            //注册
            cReg: function () {
                let url = this.host + 'wuyan/user/Register';
                let self = this;
                let postParam = {};
                postParam = this.reg;
                M.load(url, JSON.stringify(postParam), function (data) {
                    if (data.code == -1) {
                        M.topRightInfoTips({title: data.message})
                    } else {
                        M.topRightInfoTips({title: data.message})
                    }
                });
            },
            //登陆
            cLogin: function () {
                let url = this.host + 'wuyan/user/Login';
                let self = this;
                let postParam = {};
                postParam.password = this.password;
                postParam.email = this.email;
                M.load(url, JSON.stringify(postParam), function (data) {
                    if (data.code == -1) {
                        M.topRightInfoTips({title: data.message})
                        //查找权限
                        self.findjurisdiction(data.id)
                    } else {
                        M.topRightInfoTips({title: data.message})
                    }
                });
            },
            //登陆后查找信息
            findjurisdiction: function (id) {
                let url = this.host + 'wuyan/user/info/' + id;
                let self = this;
                M.load(url, '', function (data) {
                    localStorage.setItem('wyrole', data.data.role)
                    localStorage.setItem('wyname', data.data.name)
                    localStorage.setItem('wyid', data.data.id)
                    self.$set('localdata.role', data.data.role)
                    self.$set('localdata.name', data.data.name)
                    self.$set('localdata.id', data.data.id)
                }, 'get');
            },
            out: function () {
                localStorage.setItem('wyrole', '')
                localStorage.setItem('wyname', '')
                localStorage.setItem('wyid', '')
                this.$set('localdata.role', '')
                this.$set('localdata.name', '')
                this.$set('localdata.id', '')
            },
        }
    }
</script>
<style type="text/css" scoped>
    .topnav {
        height: 60px;
        line-height: 60px;
        background: white;
        border: 1px solid white;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, .2);
    }

    .topnav ul {
        overflow: hidden;
        /*width: 900px;*/
        float: left;
        padding-left: 125px;
    }

    .sign {
        text-align: center;
    }

    .topnav ul li {
        float: left;
        list-style: none;
        padding: 0 10px;
        text-align: center;
    }

    .topnav ul .active a {
        color: #3DCCAC;
        margin-bottom: -2px;
    }

    .topnav ul li a {
        text-decoration: none;
        color: #505050;
        width: 100%;
        font-size: 18px;
        font-family: 黑体;
        padding-right: 10px;
    }

    .topnav ul li:hover > a {
        color: #3DCCAC;
        text-decoration: none;
    }

    .topnav ul li:last-child > a {
        border-right: 0;
    }

    .red {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// nav.vue?70de6ffe